import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { MdArrowForwardIos } from "react-icons/md";
import PropTypes from "prop-types";
import {
  StyledAppBreadcrumbsContainer,
  StyledAppBreadcrumbsHomeIconContainer,
} from "./index.styled";
import { IoExpand } from "react-icons/io5";
import { Breadcrumb } from "antd";
import { HOME_ROUTE } from "_constants";
import { GoHomeFill } from "react-icons/go";

const AppBreadCrumbs = (props) => {
  const {
    urlToNameMap = null,
    showFullScreen = false,
    className = "",
    items = null,
    onClickFullScreen = () => null,
  } = props;

  const { pathname } = useLocation();

  const breadCrumbItems = useMemo(() => {
    if (items)
      return [
        {
          title: (
            <Link to={HOME_ROUTE}>
              <StyledAppBreadcrumbsHomeIconContainer>
                <GoHomeFill size={18} />
              </StyledAppBreadcrumbsHomeIconContainer>
            </Link>
          ),
          key: "home",
        },
      ].concat(
        items.map((item, index) => ({
          key: typeof item === "string" ? item : index,
          title: item,
        })),
      );
    const pathSnippets = pathname.split("/").filter((i) => i);
    let extraBreadcrumbItems = [];
    pathSnippets.forEach((_, index) => {
      const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
      if (urlToNameMap[url]) {
        extraBreadcrumbItems.push({
          key: url,
          title: <Link to={url}>{urlToNameMap[url]}</Link>,
        });
      }
    });

    return [
      {
        title: (
          <Link to={HOME_ROUTE}>
            <StyledAppBreadcrumbsHomeIconContainer>
              <GoHomeFill size={18} />
            </StyledAppBreadcrumbsHomeIconContainer>
          </Link>
        ),
        key: "home",
      },
    ].concat(extraBreadcrumbItems);
  }, [items, pathname, urlToNameMap]);

  return (
    <StyledAppBreadcrumbsContainer className={className}>
      <Breadcrumb
        separator={<MdArrowForwardIos size={10} />}
        items={breadCrumbItems}
      />
      {showFullScreen && (
        <span className="full-screen" onClick={onClickFullScreen}>
          <IoExpand size={18} /> Fullscreen
        </span>
      )}
    </StyledAppBreadcrumbsContainer>
  );
};
AppBreadCrumbs.propTypes = {
  urlToNameMap: PropTypes.object,
  showFullScreen: PropTypes.bool,
  onClickFullScreen: PropTypes.func,
  items: PropTypes.array,
  className: PropTypes.string,
};

export default AppBreadCrumbs;
